import { useEffect, useRef } from "react";
import { drawToast, drawEnemy, drawHero, drawWeapon } from "@/game/sprites";
import { WEAPONS } from "@/game/config";

export const TitleArt = () => {
  const ref = useRef(null);
  useEffect(() => {
    const ctx = ref.current.getContext("2d");
    let raf, t = 0;
    const loop = () => {
      t += 0.016;
      const g = ctx.createLinearGradient(0, 0, 0, 420);
      g.addColorStop(0, "#FFD9A0"); g.addColorStop(1, "#FFF3DC");
      ctx.fillStyle = g; ctx.fillRect(0, 0, 420, 420);
      ctx.fillStyle = "#E9A56A"; ctx.beginPath(); ctx.ellipse(90, 330, 140, 90, 0, Math.PI, 0); ctx.ellipse(330, 330, 150, 110, 0, Math.PI, 0); ctx.fill();
      ctx.fillStyle = "#B8601C"; ctx.fillRect(0, 320, 420, 14);
      ctx.fillStyle = "#F1CB86"; ctx.fillRect(0, 334, 420, 86);
      drawToast(ctx, 210, 140 + Math.sin(t * 2) * 8, 120);
      [[70, 90], [350, 80], [60, 230], [365, 220]].forEach(([x, y], i) => drawToast(ctx, x, y + Math.sin(t * 3 + i) * 5, 30));
      ctx.save(); ctx.translate(210, 294 - Math.abs(Math.sin(t * 4)) * 14); ctx.scale(2, 2);
      drawHero(ctx, { x: 0, y: 0, dir: 1, walk: t, onGround: true }, t);
      drawWeapon(ctx, 6, 2, -0.8 + Math.sin(t * 4) * 0.4, WEAPONS.butter_knife, 18);
      ctx.restore();
      drawEnemy(ctx, { type: "crumb", x: 90, y: 300 + Math.sin(t * 5) * 3, r: 16, hitT: 0 }, t, 0);
      drawEnemy(ctx, { type: "jam", x: 335, y: 300, r: 16, hitT: 0, seed: 1 }, t, Math.PI);
      raf = requestAnimationFrame(loop);
    };
    loop();
    return () => cancelAnimationFrame(raf);
  }, []);
  return <canvas ref={ref} width={420} height={420} className="title-art" data-testid="title-art-canvas" />;
};
